export default function getRedirectionLink(referrer: string) {
  if (referrer.includes(window.location.host)) {
    return '/';
  }
  return 'https://www.modusign.co.kr';
}
